<template>
  <AppCard
    elevation="0"
    class="SubscriptionConsumptionDrPlan"
    data-locator="subscription-consumption-plan"
  >
    <div v-if="subscriptionDataroomStoragePending" data-locator="loading-state">
      <v-skeleton-loader type="text"/>
      <v-skeleton-loader type="text"/>
    </div>
    <template v-else>
      <div class="SubscriptionConsumptionDrPlan__content">
        <h3
          class="mb-1 text--x-large font-weight-bold text-text-primary"
          data-locator="subscription-consumption-plan-title"
        >
          {{ $t(`${TRANSLATION_KEY_PREFIX}.title`, { limitGb }) }}
        </h3>
        <p class="mb-1 text--small text-text-secondary">
          {{ $t(`${TRANSLATION_KEY_PREFIX}.subscriptionDate`, { date: subscriptionDate }) }}
        </p>
        <p class="mb-0 text--small text-text-secondary">
          {{ $t(`${TRANSLATION_KEY_PREFIX}.renewalDate`, { date: renewalDate }) }}
        </p>
      </div>

      <app-button
        type="primary"
        class="SubscriptionConsumptionDrPlan__cta"
        data-locator="subscription-consumption-plan-change-offer"
        @click="onChangeOffer"
      >
        {{ $t(`${TRANSLATION_KEY_PREFIX}.changeOffer`) }}
      </app-button>
    </template>

    <!-- DIALOGS -->
    <SubscriptionConsumptionChangeOfferDialog v-if="changeOfferDialogIsOpen"
                                              @close="changeOfferDialogIsOpen = false"
    />
  </AppCard>
</template>

<script>
  import { mapState } from 'vuex'

  import lexisLogo from '@/assets/img/subscription/lexisnexis-logo.svg'
  import AppCard from '@/common/AppCard.vue'
  import { ISOToDDMMYYYY } from '@/common/utils/dates'
  import SubscriptionConsumptionChangeOfferDialog from '@/subscriptions/views/SubscriptionConsumptionChangeOfferDialog.vue'

  const TRANSLATION_KEY_PREFIX = 'subscriptions.views.SubscriptionConsumption.Plan'

  export default {
    name: 'SubscriptionConsumptionDrPlan',
    components: { AppCard, SubscriptionConsumptionChangeOfferDialog },
    data () {
      return {
        TRANSLATION_KEY_PREFIX,
        logoBackground: `url(${lexisLogo})`,
        changeOfferDialogIsOpen: false,
      }
    },
    computed: {
      ...mapState('subscription', ['subscriptionDataroomStorage', 'subscriptionDataroomStoragePending']),
      limitGb () {
        return this.subscriptionDataroomStorage?.limitGb ?? 0
      },
      subscriptionDate () {
        return ISOToDDMMYYYY(this.subscriptionDataroomStorage?.startDate)
      },
      renewalDate () {
        return ISOToDDMMYYYY(this.subscriptionDataroomStorage?.endDate)
      },
    },
    methods: {
      onChangeOffer () {
        this.changeOfferDialogIsOpen = true
      },
    },
  }
</script>

<style scoped lang="scss">
  .SubscriptionConsumptionDrPlan {
    display: flex;
    flex-direction: column;
    min-height: 200px;
    background-color: rgb(var(--v-theme-surface-tertiary));
    background-image: v-bind(logoBackground);
    background-repeat: no-repeat;
    background-position: right bottom;
  }

  :deep(.SubscriptionConsumptionDrPlan__cta) {
    align-self: flex-start;
    margin-top: auto;
  }
</style>
